import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Footer from './Component/Footer';
import Request from './Component/requestEstimate';
import Header from './Component/Header';
import homeHero from './Component/homepagephoto.png';
import homeShowroom from './Component/home/home2.jpg';
import homeLaminate from './Component/home/home1.jpg';
import homeInstall from './Component/home/home3.jpg';
import brand1 from './Component/home/brand1.png';
import carpet from './Component/product/h1.png';
import hardwood from './Component/product/h2.png';
import laminate from './Component/product/h3.png';
import Tile from './Component/product/h4.png';
import s2 from './Component/s2.png';
import inspired from './Component/inspired.png';

const products = [
	{ title: 'Carpet', href: '/products/carpet', image: carpet },
	{ title: 'Carpet Tile', href: '/products/carpet-tile', image: Tile },
	{ title: 'Hardwood', href: '/products/hardwood', image: hardwood },
	{ title: 'Luxury Vinyl', href: '/products/luxuryvinyl', image: laminate },
	{ title: 'Laminate', href: '/products/laminate', image: homeLaminate },
	{ title: 'Cork', href: '/products/cork', image: hardwood },
];

const whyUs = [
	{ title: 'Commitment to excellence', desc: 'Every install finished to a high standard.' },
	{ title: 'Everyday low prices', desc: 'Quality flooring without the markup.' },
	{ title: 'Highest quality products', desc: 'Trusted brands for home and business.' },
	{ title: 'Next day appointments', desc: 'Flexible scheduling when you need it.' },
	{ title: 'Strong supplier relationships', desc: 'Access to the latest materials fast.' },
	{ title: 'Licensed installers', desc: 'Professionals you can rely on.' },
];

const shortcuts = [
	{
		title: 'Reviews',
		text: 'See why San Rafael trusts PacifiContract.',
		href: '/reviews',
		cta: 'Read reviews',
		icon: 'bi-star-fill',
	},
	{
		title: 'Free estimate',
		text: 'Get an accurate in-home flooring consultation.',
		href: '/free-estimate',
		cta: 'Schedule now',
		icon: 'bi-calendar-check',
	},
	{
		title: 'Services',
		text: 'Installation and design help for your next project.',
		href: '/flooring-services',
		cta: 'View services',
		icon: 'bi-tools',
	},
];

function Home() {
	return (
		<div className="min-h-screen bg-[#f7f8fa] text-slate-900 antialiased">
			<Header />

			{/* Hero image (branding baked into asset) */}
			<section className="relative bg-[#0c1220]">
				<img
					src={homeHero}
					alt="PacifiContract — Quality flooring. Built on Trust."
					className="block w-full object-cover"
				/>
			</section>

			{/* Trust strip */}
			{/* <section className="border-b border-slate-200/80 bg-white">
				<div className="mx-auto grid max-w-6xl grid-cols-2 gap-px bg-slate-100 sm:grid-cols-4">
					{[
						{ label: 'Marin & Sonoma', sub: 'Local service area' },
						{ label: 'Family owned', sub: 'Since day one' },
						{ label: 'Licensed crew', sub: 'Pro installers' },
						{ label: 'Free estimates', sub: 'No obligation' },
					].map((item) => (
						<div key={item.label} className="bg-white px-4 py-5 text-center sm:py-6">
							<p className="text-sm font-semibold tracking-wide text-slate-900 sm:text-base">
								{item.label}
							</p>
							<p className="mt-1 text-xs text-slate-500 sm:text-sm">{item.sub}</p>
						</div>
					))}
				</div>
			</section> */}

			{/* Catalog */}
			<section className="relative overflow-hidden py-16 md:py-24">
				<div
					className="pointer-events-none absolute -left-24 top-10 h-72 w-72 rounded-full opacity-40 blur-3xl"
					style={{ background: 'radial-gradient(circle, rgba(0,117,202,0.18), transparent 70%)' }}
				/>
				<div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
					<div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
						<div className="max-w-xl text-left">
							<p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-[#0075ca] sm:text-xs">
								Flooring catalog
							</p>
							<h2 className="mt-3 text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl md:text-4xl">
								Find the floor that fits your space
							</h2>
							<p className="mt-3 text-sm leading-relaxed text-slate-500 sm:text-base md:text-lg">
								Browse carpet, hardwood, LVP, laminate, and more for homes and commercial spaces
								across the North Bay.
							</p>
						</div>
						<a
							href="/products"
							className="inline-flex w-fit items-center gap-2 rounded-full bg-slate-900 px-5 py-2.5 text-sm font-medium text-white no-underline transition hover:bg-slate-800"
						>
							View all products
							<span aria-hidden="true">→</span>
						</a>
					</div>

					<div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
						{products.map((product, index) => (
							<a
								key={product.href}
								href={product.href}
								className={`group relative isolate overflow-hidden no-underline ${
									index === 0 ? 'sm:col-span-2 lg:col-span-1 lg:row-span-2' : ''
								}`}
							>
								<div
									className={`relative overflow-hidden bg-slate-200 ${
										index === 0 ? 'aspect-[4/5] sm:aspect-[16/10] lg:aspect-auto lg:h-full lg:min-h-[420px]' : 'aspect-[4/3]'
									}`}
								>
									<img
										src={product.image}
										alt={product.title}
										className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
									/>
									<div className="absolute inset-0 bg-gradient-to-t from-[#0c1220]/90 via-[#0c1220]/20 to-transparent" />
									<div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-3 p-5">
										<div>
											<p className="text-[11px] font-medium uppercase tracking-[0.18em] text-white/60">
												Shop
											</p>
											<h3 className="mt-1 text-2xl font-semibold text-white">{product.title}</h3>
										</div>
										<span className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-slate-900 transition group-hover:bg-[#0075ca] group-hover:text-white">
											<span aria-hidden="true">→</span>
										</span>
									</div>
								</div>
							</a>
						))}
					</div>
				</div>
			</section>

			{/* Financing banner */}
			<section className="pb-4">
				<div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
					<a
						href="/financing"
						className="block overflow-hidden rounded-[1.75rem] ring-1 ring-slate-200/80 transition hover:ring-[#0075ca]/40"
					>
						<img src={s2} alt="Financing options" className="w-full object-cover" />
					</a>
				</div>
			</section>

			{/* Inspiration full bleed */}
			<section className="py-10 md:py-14">
				<div className="relative overflow-hidden">
					<img src={inspired} alt="Get inspired" className="w-full object-cover" />
					<div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-[#0c1220]/35 to-transparent" />
					<div className="absolute inset-0 flex items-center">
						<div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
							<a
								href="/inspiration"
								className="inline-flex items-center gap-2 rounded-full bg-white/95 px-5 py-2.5 text-sm font-semibold text-slate-900 no-underline shadow-lg backdrop-blur transition hover:bg-white"
							>
								Explore inspiration
								<span aria-hidden="true">→</span>
							</a>
						</div>
					</div>
				</div>
			</section>

			{/* About */}
			<section className="py-16 md:py-24">
				<div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
					<div className="grid items-stretch gap-8 lg:grid-cols-12 lg:gap-10">
						<div className="relative overflow-hidden rounded-[2rem] lg:col-span-7">
							<img
								src={homeShowroom}
								alt="PacifiContract showroom"
								className="h-full min-h-[320px] w-full object-cover lg:min-h-[520px]"
							/>
							<div className="absolute bottom-5 left-5 right-5 rounded-2xl bg-white/90 p-4 backdrop-blur sm:bottom-8 sm:left-8 sm:right-auto sm:max-w-xs">
								<p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#0075ca]">
									Showroom
								</p>
								<p className="mt-1 text-sm font-medium text-slate-800">
									9 Jordan St., San Rafael, CA 94901
								</p>
							</div>
						</div>

						<div className="flex flex-col justify-center rounded-[2rem] bg-white p-8 shadow-sm ring-1 ring-slate-200/70 lg:col-span-5 lg:p-10">
							<p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-[#0075ca] sm:text-xs">
								About PacifiContract
							</p>
							<h2 className="mt-3 text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl">
								Family owned &amp; operated
							</h2>
							<p className="mt-5 text-sm leading-7 text-slate-600 sm:text-[15px]">
								PacifiContract is family owned and operated. We have excellent customer service.
								We specialize in being able to service all of your flooring needs. Hardwood,
								carpet, vinyl sheet and floating floors are our specialty and we are
								perfectionists. Quality work and customer satisfaction is what we strive for.
							</p>
							<div className="mt-8 flex flex-wrap gap-3">
								<a
									href="/about-us"
									className="inline-flex items-center justify-center rounded-full bg-[#0075ca] px-5 py-2.5 text-sm font-semibold text-white no-underline transition hover:bg-[#0063ad]"
								>
									Explore more about us
								</a>
								<a
									href="tel:+14152180103"
									className="inline-flex items-center justify-center rounded-full border border-slate-300 px-5 py-2.5 text-sm font-semibold text-slate-800 no-underline transition hover:border-slate-400"
								>
									(415) 218-0103
								</a>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* Why us */}
			<section className="relative overflow-hidden bg-[#0c1220] py-16 text-white md:py-24">
				<div
					className="pointer-events-none absolute right-0 top-0 h-80 w-80 opacity-30 blur-3xl"
					style={{ background: 'radial-gradient(circle, #0075ca 0%, transparent 70%)' }}
				/>
				<div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
					<div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
						<div className="lg:col-span-5">
							<p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-[#7eb8e8] sm:text-xs">
								Why choose us
							</p>
							<h2 className="mt-3 text-2xl font-semibold tracking-tight sm:text-3xl md:text-4xl">
								Built for lasting floors — and lasting trust
							</h2>
							<p className="mt-4 text-sm leading-relaxed text-white/65 sm:text-base">
								From product selection to professional installation, we keep every step clear,
								fair, and high quality.
							</p>
							<div className="mt-8 overflow-hidden rounded-[1.5rem]">
								<img
									src={homeInstall}
									alt="Quality flooring installation"
									className="h-56 w-full object-cover md:h-64"
								/>
							</div>
							<a
								href="/free-estimate"
								className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#0075ca] px-5 py-2.5 text-sm font-semibold text-white no-underline transition hover:bg-[#0063ad]"
							>
								Request an estimate
								<span aria-hidden="true">→</span>
							</a>
						</div>

						<div className="grid gap-4 sm:grid-cols-2 lg:col-span-7">
							{whyUs.map((item, i) => (
								<div
									key={item.title}
									className="rounded-2xl border border-white/10 bg-white/[0.04] p-5 transition hover:border-[#0075ca]/50 hover:bg-white/[0.07]"
								>
									<p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#7eb8e8]">
										0{i + 1}
									</p>
									<h3 className="mt-3 text-lg font-semibold text-white">{item.title}</h3>
									<p className="mt-2 text-sm leading-relaxed text-white/60">{item.desc}</p>
								</div>
							))}
						</div>
					</div>
				</div>
			</section>

			{/* Shortcuts */}
			<section className="py-16 md:py-24">
				<div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
					<div className="mb-10 max-w-2xl">
						<p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-[#0075ca] sm:text-xs">
							Next steps
						</p>
						<h2 className="mt-3 text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl">
							Ready when you are
						</h2>
					</div>
					<div className="grid gap-5 md:grid-cols-3">
						{shortcuts.map((item) => (
							<a
								key={item.href}
								href={item.href}
								className="group flex h-full flex-col rounded-[1.75rem] bg-white p-7 no-underline shadow-sm ring-1 ring-slate-200/80 transition hover:-translate-y-1 hover:shadow-lg hover:ring-[#0075ca]/35"
							>
								<span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#0075ca]/10 text-[#0075ca]">
									<i className={`bi ${item.icon} text-xl`} />
								</span>
								<h3 className="mt-6 text-xl font-semibold text-slate-900">{item.title}</h3>
								<p className="mt-2 flex-1 text-sm leading-relaxed text-slate-500">{item.text}</p>
								<span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#0075ca]">
									{item.cta}
									<span className="transition group-hover:translate-x-1" aria-hidden="true">
										→
									</span>
								</span>
							</a>
						))}
					</div>
				</div>
			</section>

			{/* Estimate form */}
			<section className="bg-white">
				<Request />
			</section>

			{/* Brands */}
			<section className="border-t border-slate-200 bg-[#f7f8fa] py-14 md:py-20">
				<div className="mx-auto max-w-6xl px-4 text-center sm:px-6 lg:px-8">
					<p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#0075ca]">
						Partners
					</p>
					<h2 className="mt-3 text-2xl font-semibold tracking-tight text-slate-900 md:text-3xl">
						Featured brands &amp; technologies
					</h2>
					<div className="mt-10 rounded-[2rem] bg-white p-6 shadow-sm ring-1 ring-slate-200/70 sm:p-10">
						<img
							src={brand1}
							alt="Featured flooring brands"
							className="mx-auto max-w-full"
						/>
					</div>
				</div>
			</section>

			<Footer />
		</div>
	);
}

export default Home;
